/* eslint-disable */
const messages = {
  vi: {
    menu: {
      dashboard: 'Bảng điều khiển',
      content: 'Nội dung',
      folders: 'Thư mục',
      history: 'Lịch sử',
      account: 'Tài khoản',
      profile: 'Hồ sơ',
      subscription: ' Gói dịch vụ',
      billing: 'Thanh toán',
    },
    auth: {
      login: 'Đăng nhập',
      logout: 'Đăng xuất',
      register: 'Đăng ký',
      email: 'Email',
      password: 'Mật khẩu',
      confirmPassword: 'Xác nhận mật khẩu',
      loginTitle: 'Đăng nhập TTS SaaS',
      registerTitle: 'Tạo tài khoản',
      emailPlaceholder: 'Nhập email của bạn',
      passwordPlaceholder: 'Nhập mật khẩu',
      noAccount: 'Chưa có tài khoản? Đăng ký ngay',
      hasAccount: 'Đã có tài khoản? Đăng nhập',
      loginFailed: 'Đăng nhập thất bại',
      registerSuccess: 'Đăng ký thành công',
    },
    validation: {
      emailRequired: 'Email là bắt buộc',
      emailInvalid: 'Email không hợp lệ',
      passwordRequired: 'Mật khẩu là bắt buộc',
      passwordMin: 'Mật khẩu phải có ít nhất 8 ký tự',
      passwordMismatch: 'Mật khẩu xác nhận không khớp',
      usernameRequired: 'Tên đăng nhập là bắt buộc',
    },
    admin: {
      dashboard: 'Bảng điều khiển',
      customers: 'Khách hàng',
      commerce: 'Thương mại',
      plans: 'Gói dịch vụ',
      subscriptions: 'Đăng ký',
      payments: 'Thanh toán',
      tts: 'TTS',
      ttsJobs: 'Công việc TTS',
      queue: 'Hàng đợi',
      auditLogs: 'Nhật ký kiểm tra',
      admins: 'Quản trị viên',
    },
    common: {
      save: 'Lưu',
      cancel: 'Hủy',
      delete: 'Xóa',
      edit: 'Sửa',
      create: 'Tạo mới',
      confirm: 'Xác nhận',
      loading: 'Đang tải...',
      success: 'Thành công',
      error: 'Lỗi',
      retry: 'Thử lại',
      refresh: 'Làm mới',
      view: 'Xem',
      viewAll: 'Xem tất cả',
      back: 'Quay lại',
      search: 'Tìm kiếm',
      yes: 'Có',
      no: 'Không',
    },
    subscription: {
      currentPlan: 'Gói hiện tại',
      quotaUsage: 'Mức sử dụng hạn mức',
      month: 'tháng',
      charLimit: 'Giới hạn ký tự',
      concurrentJobs: 'Job đồng thời',
      storage: 'Lưu trữ',
      billingCycle: 'Chu kỳ thanh toán',
      autoRenew: 'Tự động gia hạn',
      cancelPlan: 'Hủy gói',
      currentPeriod: 'Kỳ hiện tại: {start} → {end}',
      noActiveSubscription: 'Bạn chưa có gói đăng ký nào.',
      viewPlans: 'Xem các gói',
      availablePlans: 'Các gói có sẵn',
      chars: 'ký tự',
      subscribe: 'Đăng ký ngay',
      currentPlanLabel: 'Gói hiện tại',
      periodEndsOn: 'Kỳ kết thúc vào {date}',
      checkoutStarted: 'Đã bắt đầu thanh toán.',
      checkoutFailed: 'Thanh toán thất bại.',
      cancelConfirm: 'Bạn có chắc muốn hủy gói đăng ký này? Hành động này không thể hoàn tác.',
      cancelled: 'Đã hủy gói đăng ký.',
    },
    usage: {
      charsUsed: 'Ký tự đã dùng',
      jobsCount: 'Số job',
      storageUsed: 'Dung lượng đã dùng',
    },
    tts: {
      recentJobs: 'Các job TTS gần đây',
      title: 'Tiêu đề',
      status: {
        pending: 'Đang chờ',
        queued: 'Đã xếp hàng',
        processing: 'Đang xử lý',
        completed: 'Hoàn thành',
        failed: 'Thất bại',
        cancelled: 'Đã hủy',
      },
      statusAll: 'Tất cả',
      createdAt: 'Ngày tạo',
      actions: 'Hành động',
      noJobs: 'Chưa có job TTS nào.',
      noJobsStatus: 'Không có job nào ở trạng thái này.',
      noResults: 'Không tìm thấy kết quả.',
      searchPlaceholder: 'Tìm kiếm theo tiêu đề tài liệu...',
      document: 'Tài liệu TTS',
      documentContent: 'Nội dung tài liệu',
      runTTS: 'Chạy TTS',
      noActiveSubscription: 'Không có gói hoạt động',
      noActiveSubscriptionDesc: 'Bạn cần đăng ký gói để sử dụng tính năng TTS.',
      upgradePlan: 'Nâng cấp gói',
      jobProgress: 'Tiến trình',
      jobQueued: 'Job đang trong hàng đợi...',
      jobProcessing: 'Đang xử lý... {progress}%',
      jobPending: 'Job đang chờ...',
      cancelJob: 'Hủy job',
      jobCompleted: 'Hoàn thành',
      jobCompletedDesc: 'Đã tạo xong audio với {chars} ký tự.',
      downloadAudio: 'Tải audio',
      jobFailed: 'Thất bại',
      jobFailedUnknown: 'Đã xảy ra lỗi không xác định.',
      retry: 'Thử lại',
      runAgain: 'Chạy lại',
      voiceSelection: 'Chọn giọng',
      selectVoice: 'Chọn giọng nói...',
      modelSelection: 'Chọn mô hình',
      selectModel: 'Chọn mô hình...',
      methodSelection: 'Phương án TTS',
      selectMethod: 'Chọn phương án...',
      submitJob: 'Bắt đầu TTS',
      cancel: 'Hủy',
      cancelJobConfirm: 'Bạn có chắc muốn hủy job này?',
      cancelJobConfirmWithTitle: 'Bạn có chắc muốn hủy job "{title}"?',
      jobCancelled: 'Đã hủy job.',
      editDocument: 'Sửa tài liệu',
      documentSaved: 'Đã lưu tài liệu.',
      loadFailed: 'Không thể tải tài liệu.',
      saveFailed: 'Lưu thất bại.',
      submitFailed: 'Gửi job thất bại.',
      jobSubmitted: 'Đã gửi job TTS.',
      progress: 'Tiến trình',
      elapsed: 'Đã chạy',
      remaining: 'Còn lại',
    },
    dashboard: {
      emptyFirstRun: 'Bạn chưa có gói dịch vụ, tài liệu hoặc job nào. Hãy tạo nội dung đầu tiên để bắt đầu.',
      goToFolders: 'Đi đến thư mục',
      ofLimit: 'Trên tổng {value}',
      documentsCount: '{count} tài liệu',
      characters: 'ký tự',
      periodEnds: 'Kỳ hiện tại kết thúc vào {date}',
      noActivePlan: 'Chưa có gói',
      noSubscriptionYet: 'Chưa có đăng ký hoạt động',
      noDocumentsYet: 'Bạn chưa có tài liệu nào để tạo job.',
      partialLoadError: 'Một phần dữ liệu bảng điều khiển chưa tải được.',
      percentUsed: '{value}% đã dùng',
      subscriptionStatus: {
        active: 'Đang hoạt động',
        past_due: 'Quá hạn thanh toán',
        cancelled: 'Đã hủy',
        expired: 'Đã hết hạn',
        trialing: 'Đang dùng thử',
      },
    },
    folders: {
      title: 'Thư mục',
      empty: 'Bạn chưa có thư mục nào. Tạo thư mục đầu tiên để bắt đầu.',
      createFolder: 'Tạo thư mục mới',
      editFolder: 'Sửa thư mục',
      name: 'Tên thư mục',
      namePlaceholder: 'Nhập tên thư mục',
      nameRequired: 'Tên thư mục là bắt buộc.',
      nameLength: 'Tên thư mục phải từ 1-100 ký tự.',
      description: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả (tùy chọn)',
      color: 'Màu sắc',
      documents: 'tài liệu',
      createdOn: 'Đã tạo vào {date}',
      newDocument: 'Tạo tài liệu mới',
      documentTitle: 'Tiêu đề',
      documentTitlePlaceholder: 'Nhập tiêu đề tài liệu',
      documentContent: 'Nội dung',
      documentContentPlaceholder: 'Nhập nội dung văn bản cần chuyển thành giọng nói...',
      titleRequired: 'Tiêu đề là bắt buộc.',
      contentRequired: 'Nội dung là bắt buộc.',
      noDocuments: 'Thư mục này chưa có tài liệu nào.',
      deleteConfirm: 'Bạn có chắc muốn xóa thư mục "{name}"? Tất cả tài liệu trong thư mục sẽ bị xóa.',
      deleteFolderConfirm: 'Bạn có chắc muốn xóa thư mục này?',
      deleteDocConfirm: 'Bạn có chắc muốn xóa tài liệu "{title}"?',
      created: 'Đã tạo thư mục.',
      updated: 'Đã cập nhật thư mục.',
      deleted: 'Đã xóa thư mục.',
      folderDeleted: 'Đã xóa thư mục.',
      documentCreated: 'Đã tạo tài liệu.',
      documentDeleted: 'Đã xóa tài liệu.',
      createDocFailed: 'Tạo tài liệu thất bại.',
      loadFailed: 'Không thể tải thư mục.',
      updateFailed: 'Cập nhật thất bại.',
      saveFailed: 'Lưu thất bại.',
      folderUpdated: 'Đã cập nhật thư mục.',
    },
    profile: {
      accountInfo: 'Thông tin tài khoản',
      email: 'Email',
      username: 'Tên đăng nhập',
      usernamePlaceholder: 'Nhập tên đăng nhập',
      usernameLength: 'Tên đăng nhập phải từ 3-50 ký tự.',
      fullName: 'Họ và tên',
      fullNamePlaceholder: 'Nhập họ và tên',
      avatarUrl: 'URL Avatar',
      avatarUrlPlaceholder: 'https://example.com/avatar.png',
      emailHint: 'Email không thể thay đổi.',
      accountDetails: 'Chi tiết tài khoản',
      joinedAt: 'Ngày tham gia',
      emailVerified: 'Đã xác minh email',
      accountStatus: 'Trạng thái',
      locked: 'Bị khóa',
      active: 'Hoạt động',
      saveFailed: 'Lưu thất bại.',
      saved: 'Đã lưu hồ sơ.',
    },
    billing: {
      paymentHistory: 'Lịch sử thanh toán',
      date: 'Ngày',
      description: 'Mô tả',
      amount: 'Số tiền',
      statusLabel: 'Trạng thái',
      transactionId: 'Mã giao dịch',
      failureReason: 'Lý do thất bại',
      subscriptionPayment: 'Thanh toán đăng ký',
      unknownError: 'Lỗi không xác định',
      noTransactions: 'Bạn chưa có giao dịch thanh toán nào.',
      summary: 'Tóm tắt',
      totalSpent: 'Tổng chi',
      completedPayments: 'Thanh toán thành công',
      failedPayments: 'Thanh toán thất bại',
      statuses: {
        pending: 'Đang chờ',
        completed: 'Hoàn thành',
        failed: 'Thất bại',
        refunded: 'Đã hoàn tiền',
      },
    },
  },
  en: {
    menu: {
      dashboard: 'Dashboard',
      content: 'Content',
      folders: 'Folders',
      history: 'History',
      account: 'Account',
      profile: 'Profile',
      subscription: 'Subscription',
      billing: 'Billing',
    },
    auth: {
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      loginTitle: 'Login to TTS SaaS',
      registerTitle: 'Create Account',
      emailPlaceholder: 'Enter your email',
      passwordPlaceholder: 'Enter your password',
      noAccount: "Don't have an account? Register",
      hasAccount: 'Already have an account? Login',
      loginFailed: 'Login failed',
      registerSuccess: 'Registration successful',
    },
    validation: {
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email address',
      passwordRequired: 'Password is required',
      passwordMin: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      usernameRequired: 'Username is required',
    },
    admin: {
      dashboard: 'Dashboard',
      customers: 'Customers',
      commerce: 'Commerce',
      plans: 'Plans',
      subscriptions: 'Subscriptions',
      payments: 'Payments',
      tts: 'TTS',
      ttsJobs: 'TTS Jobs',
      queue: 'Queue',
      auditLogs: 'Audit Logs',
      admins: 'Admins',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      confirm: 'Confirm',
      loading: 'Loading...',
      success: 'Success',
      error: 'Error',
      retry: 'Retry',
      refresh: 'Refresh',
      view: 'View',
      viewAll: 'View all',
      back: 'Back',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
    },
    subscription: {
      currentPlan: 'Current plan',
      quotaUsage: 'Quota usage',
      month: 'month',
      charLimit: 'Character limit',
      concurrentJobs: 'Concurrent jobs',
      storage: 'Storage',
      billingCycle: 'Billing cycle',
      autoRenew: 'Auto renew',
      cancelPlan: 'Cancel plan',
      currentPeriod: 'Current period: {start} → {end}',
      noActiveSubscription: 'You have no active subscription.',
      viewPlans: 'View plans',
      availablePlans: 'Available plans',
      chars: 'chars',
      subscribe: 'Subscribe',
      currentPlanLabel: 'Current plan',
      periodEndsOn: 'Period ends on {date}',
      checkoutStarted: 'Checkout started.',
      checkoutFailed: 'Checkout failed.',
      cancelConfirm: 'Are you sure you want to cancel your subscription? This cannot be undone.',
      cancelled: 'Subscription cancelled.',
    },
    usage: {
      charsUsed: 'Characters used',
      jobsCount: 'Jobs count',
      storageUsed: 'Storage used',
    },
    tts: {
      recentJobs: 'Recent TTS jobs',
      title: 'Title',
      status: {
        pending: 'Pending',
        queued: 'Queued',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled',
      },
      statusAll: 'All',
      createdAt: 'Created at',
      actions: 'Actions',
      noJobs: 'No TTS jobs yet.',
      noJobsStatus: 'No jobs with this status.',
      noResults: 'No results found.',
      searchPlaceholder: 'Search by document title...',
      document: 'TTS Document',
      documentContent: 'Document content',
      runTTS: 'Run TTS',
      noActiveSubscription: 'No active subscription',
      noActiveSubscriptionDesc: 'You need an active subscription to use TTS.',
      upgradePlan: 'Upgrade plan',
      jobProgress: 'Progress',
      jobQueued: 'Job is queued...',
      jobProcessing: 'Processing... {progress}%',
      jobPending: 'Job is pending...',
      cancelJob: 'Cancel job',
      jobCompleted: 'Completed',
      jobCompletedDesc: 'Audio generated from {chars} characters.',
      downloadAudio: 'Download audio',
      jobFailed: 'Failed',
      jobFailedUnknown: 'An unknown error occurred.',
      retry: 'Retry',
      runAgain: 'Run again',
      voiceSelection: 'Voice selection',
      selectVoice: 'Select a voice...',
      modelSelection: 'Model selection',
      selectModel: 'Select a model...',
      methodSelection: 'TTS method',
      selectMethod: 'Select a method...',
      submitJob: 'Start TTS',
      cancel: 'Cancel',
      cancelJobConfirm: 'Are you sure you want to cancel this job?',
      cancelJobConfirmWithTitle: 'Are you sure you want to cancel job "{title}"?',
      jobCancelled: 'Job cancelled.',
      editDocument: 'Edit document',
      documentSaved: 'Document saved.',
      loadFailed: 'Failed to load document.',
      saveFailed: 'Save failed.',
      submitFailed: 'Failed to submit job.',
      jobSubmitted: 'TTS job submitted.',
      progress: 'Progress',
      elapsed: 'Elapsed',
      remaining: 'Remaining',
    },
    dashboard: {
      emptyFirstRun: 'You do not have a subscription, document, or job yet. Create your first content item to get started.',
      goToFolders: 'Go to folders',
      ofLimit: 'Of {value}',
      documentsCount: '{count} documents',
      characters: 'characters',
      periodEnds: 'Current period ends on {date}',
      noActivePlan: 'No active plan',
      noSubscriptionYet: 'No active subscription yet',
      noDocumentsYet: 'You do not have any documents to generate jobs from.',
      partialLoadError: 'Some dashboard data could not be loaded.',
      percentUsed: '{value}% used',
      subscriptionStatus: {
        active: 'Active',
        past_due: 'Past due',
        cancelled: 'Cancelled',
        expired: 'Expired',
        trialing: 'Trialing',
      },
    },
    folders: {
      title: 'Folders',
      empty: 'You have no folders yet. Create your first folder to get started.',
      createFolder: 'Create new folder',
      editFolder: 'Edit folder',
      name: 'Folder name',
      namePlaceholder: 'Enter folder name',
      nameRequired: 'Folder name is required.',
      nameLength: 'Folder name must be 1-100 characters.',
      description: 'Description',
      descriptionPlaceholder: 'Enter description (optional)',
      color: 'Color',
      documents: 'documents',
      createdOn: 'Created on {date}',
      newDocument: 'New document',
      documentTitle: 'Title',
      documentTitlePlaceholder: 'Enter document title',
      documentContent: 'Content',
      documentContentPlaceholder: 'Enter the text content to convert to speech...',
      titleRequired: 'Title is required.',
      contentRequired: 'Content is required.',
      noDocuments: 'This folder has no documents yet.',
      deleteConfirm: 'Are you sure you want to delete folder "{name}"? All documents in this folder will be deleted.',
      deleteFolderConfirm: 'Are you sure you want to delete this folder?',
      deleteDocConfirm: 'Are you sure you want to delete document "{title}"?',
      created: 'Folder created.',
      updated: 'Folder updated.',
      deleted: 'Folder deleted.',
      folderDeleted: 'Folder deleted.',
      documentCreated: 'Document created.',
      documentDeleted: 'Document deleted.',
      createDocFailed: 'Failed to create document.',
      loadFailed: 'Failed to load folder.',
      updateFailed: 'Update failed.',
      saveFailed: 'Save failed.',
      folderUpdated: 'Folder updated.',
    },
    profile: {
      accountInfo: 'Account information',
      email: 'Email',
      username: 'Username',
      usernamePlaceholder: 'Enter username',
      usernameLength: 'Username must be 3-50 characters.',
      fullName: 'Full name',
      fullNamePlaceholder: 'Enter full name',
      avatarUrl: 'Avatar URL',
      avatarUrlPlaceholder: 'https://example.com/avatar.png',
      emailHint: 'Email cannot be changed.',
      accountDetails: 'Account details',
      joinedAt: 'Joined at',
      emailVerified: 'Email verified',
      accountStatus: 'Account status',
      locked: 'Locked',
      active: 'Active',
      saveFailed: 'Save failed.',
      saved: 'Profile saved.',
    },
    billing: {
      paymentHistory: 'Payment history',
      date: 'Date',
      description: 'Description',
      amount: 'Amount',
      statusLabel: 'Status',
      transactionId: 'Transaction ID',
      failureReason: 'Failure reason',
      subscriptionPayment: 'Subscription payment',
      unknownError: 'Unknown error',
      noTransactions: 'You have no payment transactions yet.',
      summary: 'Summary',
      totalSpent: 'Total spent',
      completedPayments: 'Completed payments',
      failedPayments: 'Failed payments',
      statuses: {
        pending: 'Pending',
        completed: 'Completed',
        failed: 'Failed',
        refunded: 'Refunded',
      },
    },
  },
};

export default messages;
